import {
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  Button,
  FormControl,
  Grid2,
  FormLabel,
  TextField,
  Tooltip,
} from "@mui/material";
import { useState } from "react";
import { CloseOutlined } from "@mui/icons-material";
import { useGlobalModalContext } from "../../context/GlobalModalContext";
import { formatDateForInput } from "../../utils/helper";
import CustomTooltip from "../CustomTooltip";

const MeetingSchedulerDialog = ({ emails, dateTime }) => {
  // console.log(emails, "emails from scheduler");
  // console.log(dateTime, "dateTime from scheduler");
  const { hideAllModal, hideModal } = useGlobalModalContext();

  const [emailList, setEmailList] = useState(emails);
  const [emailErr, setEmailErr] = useState(false);
  const [startTime, setStartTime] = useState(formatDateForInput(dateTime));
  const [startTimeError, setStartTimeError] = useState(false);
  const [duration, setDuration] = useState(30);
  const [durationErr, setDurationErr] = useState(false);

  const handleEmailChange = (e) => {
    setEmailList(e.target.value);
  };

  const handleDuration = (e) => {
    setDuration(e.target.value);
  };

  const handleStartTime = (e) => {
    setStartTime(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setEmailErr(false);
    setDurationErr(false);
    setStartTimeError(false);
    if (!emailList) {
      setEmailErr(true);
      return;
    }
    hideModal();
  };

  return (
    <Dialog open onClose={hideModal} maxWidth={"md"} fullWidth={true}>
      <DialogTitle>
        <h4 className="font-bold text-center">Schedule Meeting</h4>
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={hideModal}
        sx={(theme) => ({
          position: "absolute",
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseOutlined />
      </IconButton>
      <DialogContent>
        <form onSubmit={handleSubmit}>
          <Grid2 container direction={"row"} rowGap={2}>
            <FormControl size="small" fullWidth required error={emailErr}>
              <FormLabel sx={{ fontWeight: "bold" }}>
                Recipient Email(s):
              </FormLabel>
              <TextField
                size="small"
                value={emailList}
                required
                onChange={handleEmailChange}
              />
            </FormControl>
            <FormControl size="small" fullWidth required error={startTimeError}>
              <FormLabel sx={{ fontWeight: "bold" }}>
                Meeting Start Time:
              </FormLabel>
              <TextField
                size="small"
                type="datetime-local"
                value={startTime}
                required
                onChange={handleStartTime}
              />
            </FormControl>
            <FormControl size="small" fullWidth required error={durationErr}>
              <FormLabel sx={{ fontWeight: "bold" }}>
                Duration (minutes):
              </FormLabel>
              <TextField
                size="small"
                type="number"
                required
                value={duration}
                onChange={handleDuration}
              />
            </FormControl>
          </Grid2>
          <Grid2 my={2}>
          <CustomTooltip title="Functionality not yet integrated.">
            <Button
              type="submit"
              variant="contained"
              size="small"
              sx={{ textTransform: "none" }}
            >
              Schedule Meeting
            </Button>
            </CustomTooltip>
          </Grid2>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default MeetingSchedulerDialog;
